import { render, staticRenderFns } from "./SoccerHowWriteFormImageSlider.vue?vue&type=template&id=fa5b1f3a&scoped=true&"
import script from "./SoccerHowWriteFormImageSlider.vue?vue&type=script&lang=js&"
export * from "./SoccerHowWriteFormImageSlider.vue?vue&type=script&lang=js&"
import style0 from "./SoccerHowWriteFormImageSlider.vue?vue&type=style&index=0&id=fa5b1f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5b1f3a",
  null
  
)

export default component.exports